(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ptab-panel__rte table').forEach(function (table) {
    if (table.closest('.ptable-scroll')) return;

    if (table.querySelectorAll('thead th').length) {
      table.classList.add('is-stacked');
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'ptable-scroll';
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });

  document.querySelectorAll('[data-ptabs]').forEach(function (root) {
    var links = root.querySelectorAll('.ptab-link');
    var panels = root.querySelectorAll('.ptab-panel');
    var indicator = root.querySelector('[data-ptabs-indicator]');
    var accHeads = root.querySelectorAll('.ptab-accordion-head');

    function moveIndicator(link) {
      if (!indicator || !link) return;
      indicator.style.width = link.offsetWidth + 'px';
      indicator.style.transform = 'translateX(' + (link.offsetLeft - 5) + 'px)';
    }

    function activateTab(i) {
      links.forEach(function (l) {
        var on = l.getAttribute('data-tab') == i;
        l.classList.toggle('is-active', on);
        l.setAttribute('aria-selected', on);
        if (on) moveIndicator(l);
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-panel') == i);
      });
    }

    links.forEach(function (l) {
      l.addEventListener('click', function () {
        activateTab(l.getAttribute('data-tab'));
      });
    });

    var active = root.querySelector('.ptab-link.is-active');
    if (active) requestAnimationFrame(function () { moveIndicator(active); });
    window.addEventListener('resize', function () {
      var a = root.querySelector('.ptab-link.is-active');
      if (a) moveIndicator(a);
    });

    accHeads.forEach(function (head) {
      head.addEventListener('click', function () {
        var body = head.nextElementSibling;
        var isOpen = head.classList.contains('is-active');
        if (isOpen) {
          head.classList.remove('is-active');
          head.setAttribute('aria-expanded', 'false');
          body.style.maxHeight = body.scrollHeight + 'px';
          requestAnimationFrame(function () {
            body.style.maxHeight = '0px';
          });
        } else {
          head.classList.add('is-active');
          head.setAttribute('aria-expanded', 'true');
          body.style.maxHeight = body.scrollHeight + 'px';
          body.addEventListener('transitionend', function handler(e) {
            if (e.propertyName === 'max-height' && head.classList.contains('is-active')) {
              body.style.maxHeight = 'none';
            }
            body.removeEventListener('transitionend', handler);
          });
        }
      });
    });

    if (window.matchMedia('(max-width: 768px)').matches) {
      var firstBody = root.querySelector('.ptab-panel.is-active .ptab-panel__body');
      if (firstBody) firstBody.style.maxHeight = firstBody.scrollHeight + 'px';
    }

    var mql = window.matchMedia('(max-width: 768px)');
    function handleBreakpointChange(e) {
      if (!e.matches) {
        root.querySelectorAll('.ptab-panel__body').forEach(function (body) {
          body.style.maxHeight = '';
        });
      } else {
        var openHead = root.querySelector('.ptab-accordion-head.is-active');
        if (openHead) {
          var openBody = openHead.nextElementSibling;
          openBody.style.maxHeight = openBody.scrollHeight + 'px';
        }
      }
    }
    if (mql.addEventListener) {
      mql.addEventListener('change', handleBreakpointChange);
    } else if (mql.addListener) {
      mql.addListener(handleBreakpointChange);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
